import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.SUPABASE_URL;
const supabaseAnonKey = process.env.SUPABASE_ANON_KEY;

let supabase: SupabaseClient | null = null;
let connectionError: string | null = null;

if (supabaseUrl && supabaseAnonKey) {
    try {
        supabase = createClient(supabaseUrl, supabaseAnonKey);
    } catch (e) {
        connectionError = "Failed to initialize Supabase client.";
        console.error(e);
    }
} else {
    console.warn("Supabase configuration is missing. Some features may not work correctly.");
}

export { supabase, connectionError };
